import React from 'react';
import styled from 'styled-components';
import { FeedbackCommentBodyWithIndex, INDICATOR_SUMMARY_QUESTION_ID } from '../../../utils';
import { toUserType } from 'donor/portal/pages/FeedbackDashboard/Feedback/api';
import { FeedbackCommentRender } from 'donor/portal/pages/FeedbackDashboard/Feedback/FeedbackComment';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { useFeedback } from '../../../../BetaFeedback/FeedbackProvider';
import { isCommentNewSinceResolved } from '../../../../BetaFeedback/Feedback/utils';

interface ImpactCommentsProps {
  feedback: FeedbackCommentBodyWithIndex[];
  className?: string;
}

const StyledDiv = styled.div`
  margin: 0 auto;
  max-width: 930px;
  padding-bottom: ${SPACERS.medium};
  .impact-comments-wrapper {
    border-radius: ${SPACERS.tiny};
    border: 2px solid ${COLORS.grayLight};
    padding: ${SPACERS.large} ${SPACERS.large} 12px ${SPACERS.large};
  }
`;

const noOp = () => null;
const ImpactComments: React.FC<ImpactCommentsProps> = ({
  feedback,
  className,
}) => {
  const { getLastResolvedAt } = useFeedback();
  return (
    <StyledDiv className={className}>
      <div className="impact-comments-wrapper">
        {feedback.map(c => (
          <FeedbackCommentRender
            key={c.commentId}
            details={c.details}
            userId={c.userId}
            accountType={toUserType(c.userType)}
            createdAt={c.createdAt}
            isNew={isCommentNewSinceResolved(
              c,
              getLastResolvedAt(c.questionId || INDICATOR_SUMMARY_QUESTION_ID),
            )}
            edit={false}
            email={c.userEmail}
            errorMessage={undefined}
            handleCancel={noOp}
            name={c.userName}
            onDelete={noOp}
            onSave={noOp}
            setEdit={noOp}
            text={c.comment}
          />
        ))}
      </div>
    </StyledDiv>
  );
};

export default ImpactComments;
